import axios from "axios";


const getVideoInfo = async (video: { url: string }) => {
  const videoUrl = encodeURI(video.url);
  if (!videoUrl) {
    return null;
  }

  const response = await axios.get(`https://vimeo.com/api/oembed.json?url=${videoUrl}&width=1920`).catch(() => null);

  if (response && response.data && response.data.thumbnail_url_with_play_button && response.data.video_id) {
    return {
      src: response.data.thumbnail_url_with_play_button as string,
      videoUrl: video.url,
      videoHtml: response.data.html as string,
      alt: `Videos ${response.data.video_id}`,
    };
  }
};

const getVideoPreviews = async (videos: { url: string }[]) => {
  const listToReturn: { src: string; videoUrl: string; videoHtml: string; alt: string; }[] = [];

  const promises = videos.filter(Boolean).map(async (video: { url: string }) => {
    const videoInfo = await getVideoInfo(video);
    
    if (videoInfo) {
      listToReturn.push(videoInfo);
    }
  });

  await Promise.all(promises);

  return listToReturn;
};

export default getVideoPreviews;
